interface AccountDisabledProps {
  onLogOut: () => void;
}

export const AccountDisabled: React.FC<AccountDisabledProps> = ({
  onLogOut,
}) => {
  return (
    <div className='flex min-h-screen items-center justify-center bg-grey-100'>
      <div className='rounded-lg bg-white p-8 text-center shadow-lg'>
        <h1 className='mb-4 text-2xl font-bold text-grey-900'>
          Account Disabled
        </h1>
        <p className='mb-6 text-grey-600'>
          Your account has been disabled. Please contact an administrator.
        </p>
        <button
          onClick={onLogOut}
          className='rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700'
        >
          Log Out
        </button>
      </div>
    </div>
  );
};
